export enum GROUP_STATUS {
  active = 'active',
  inactive = 'inactive',
}
